import React, { Dispatch } from "react";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
import Icon from "~/common/Icons/Standard";
import Popover from "~/common/Popover";
interface Props {
  addCasters: boolean;
  casterHeight: number;
  selectedHeight: string;
  includeCasterInHeight: boolean;
  quantity: number;
  setQuantity: Dispatch<React.SetStateAction<number>>;
  cutDownPrice: number;
  casterItemPrice: number;
  numberOfLegs: number;
  productPrice: number;
  hasQuantityDiscounts: boolean;
  quantityDiscountPrice?: number;
  quantityDiscountQty?: number;
}
const ProductCutDownTable = ({
  addCasters,
  casterHeight,
  selectedHeight,
  includeCasterInHeight,
  quantity,
  setQuantity,
  cutDownPrice,
  casterItemPrice,
  numberOfLegs,
  productPrice,
  hasQuantityDiscounts,
  quantityDiscountPrice = 0,
  quantityDiscountQty = 0
}: Props) => {
  const priceToUse = hasQuantityDiscounts && quantity >= quantityDiscountQty ? quantityDiscountPrice : productPrice;
  return <>
      <div className="grid grid-cols-2 text-sm font-semibold border-t border-b-0 border-l-0 border-r-0 border-solid border-gray-200">
        <div className="mt-2.5">Height</div>
        <div className="text-right mt-2.5">
          {includeCasterInHeight && addCasters ? Number(selectedHeight) - casterHeight : Number(selectedHeight)}
          &quot;
        </div>
      </div>
      {addCasters && <div className="grid grid-cols-2 text-sm font-semibold">
          <div className="mt-2.5">Height w/Casters</div>
          <div className="text-right mt-2.5">
            {includeCasterInHeight && addCasters ? Number(selectedHeight) : Number(selectedHeight) + casterHeight}
            &quot;
          </div>
        </div>}
      <div className="grid grid-cols-2 text-sm font-semibold">
        <div className="mt-2.5">Quantity</div>
        <div className="text-right mt-2.5">
          <input id="inputQuantity" className="text-sm font-semibold" data-testid="inputQuantity" type="number" name="qty_1" autoComplete="off" value={quantity} onChange={event => {
          setQuantity(Number(event.target.value) > 0 ? Number(event.target.value) : 1);
        }} style={{
          width: "40px"
        }} />
        </div>
      </div>
      <div className="grid grid-cols-2 text-sm font-semibold">
        <div>Price Breakdown</div>
      </div>
      <div className="grid grid-cols-2">
        <div className="text-xs font-normal">
          Product&nbsp;
          {quantity < quantityDiscountQty && <Popover triggerElement={(ref: React.RefObject<HTMLAnchorElement>) => <a href="#product" className="align-text-top" ref={ref} style={{
          lineHeight: 0
        }}>
                  <Icon className="w-3 h-3 fill-current" name="question" />
                </a>} options={{
          placement: "right",
          animation: "none"
        }} title="Quantity Discount Savings">
              <p>
                Get a discounted price when you buy {quantityDiscountQty} or
                more of this item.
              </p>
            </Popover>}
        </div>
        <div className="text-sm font-semibold text-right">
          {formatAsCurrency.formatIfUndefined(priceToUse * quantity)}
        </div>
      </div>
      <div className="flex flex-row-reverse space-x-2 space-x-reverse text-xs mb-1">
        <div className="w-1/6 text-right">
          at {formatAsCurrency.formatIfUndefined(priceToUse)}
        </div>
        <div className="text-white text-center align-middle bg-gray-600 px-1 rounded">
          {quantity}
        </div>
      </div>
      <div className="grid grid-cols-2">
        <div className="text-xs font-normal mt-2.5">Cut Down Charge</div>
        <div className="text-sm font-semibold text-right mt-2.5">
          {formatAsCurrency.formatIfUndefined(cutDownPrice * quantity)}
        </div>
      </div>
      <div className="flex flex-row-reverse space-x-2 space-x-reverse text-xs mb-1">
        <div className="w-1/6 text-right">
          at {formatAsCurrency.formatIfUndefined(cutDownPrice)}
        </div>
        <div className="text-white text-center align-middle bg-gray-600 px-1 rounded">
          {quantity}
        </div>
      </div>
      {addCasters && <>
          <div className="grid grid-cols-2">
            <div className="text-xs font-normal mt-2.5">
              Casters x {numberOfLegs} Legs
            </div>
            <div className="text-sm font-semibold text-right mt-2.5">
              {formatAsCurrency.formatIfUndefined(casterItemPrice * quantity)}
            </div>
          </div>
          <div className="flex flex-row-reverse space-x-2 space-x-reverse text-xs mb-1">
            <div className="w-1/6 text-right">
              at {formatAsCurrency.formatIfUndefined(casterItemPrice)}
            </div>
            <div className="text-white text-center align-middle bg-gray-600 px-1 rounded">
              {quantity}
            </div>
          </div>
        </>}
      <div className="grid grid-cols-2 text-sm font-semibold border-t border-b-0 border-l-0 border-r-0 border-solid border-gray-200">
        <div className="text-lg font-semibold mt-2.5">Total</div>
        <div className="text-base font-semibold mt-2.5 text-right">
          {formatAsCurrency.formatIfUndefined((priceToUse + cutDownPrice + (addCasters ? casterItemPrice : 0)) * quantity)}
        </div>
      </div>
    </>;
};
export default ProductCutDownTable;